<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>
<script>
require('./assets/css/flexible.css')
require('./assets/js/flexible.js')
require('./assets/css/reset.css')
require('./assets/css/common.css');
export default {
  name: 'app',
  components: {},
  watch: {

  },
  created() {

  },
  methods: {},
  computed: {

  },
}
</script>
<style>
#app {
  width: 100%;
  height: 100%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>